import { motion } from 'framer-motion'
import { Target, TrendingUp, Calendar } from 'lucide-react'
import { FeatureCard } from './FeatureCard'
import { fadeInWithDelay, withReducedMotion } from '@/lib/animations'

/**
 * Features section for landing page
 * Displays three key features in a grid
 */
export function FeaturesSection() {
  return (
    <section id="features" className="scroll-mt-20 bg-white py-24 dark:bg-slate-950 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          className="mb-16 text-center"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={withReducedMotion(fadeInWithDelay(0.1))}
        >
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 dark:text-white sm:text-4xl">
            Everything you need to{' '}
            <span className="text-purple-400">excel</span>
          </h2>
          <p className="mt-4 text-lg text-slate-600 dark:text-slate-400">
            Track your progress, stay consistent, and achieve your aerial goals
          </p>
        </motion.div>

        {/* Feature Cards Grid */}
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <FeatureCard
            icon={Target}
            title="Track Progress"
            description="Log your training sessions, skills learned, and milestones achieved. See your journey visualized and celebrate every victory."
            delay={0.1}
          />
          <FeatureCard
            icon={TrendingUp}
            title="Stay Consistent"
            description="Build lasting habits with streak tracking and reminders. Watch your consistency grow as you train regularly."
            delay={0.2}
          />
          <FeatureCard
            icon={Calendar}
            title="Achieve Goals"
            description="Set meaningful goals and break them down into actionable steps. Track your progress and stay motivated."
            delay={0.3}
          />
        </div>
      </div>
    </section>
  )
}
